import { render, staticRenderFns } from "./FeatureBadge.vue?vue&type=template&id=c88266dc&scoped=true&"
import script from "./FeatureBadge.vue?vue&type=script&lang=ts&"
export * from "./FeatureBadge.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureBadge.vue?vue&type=style&index=0&id=c88266dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88266dc",
  null
  
)

export default component.exports